// 🗺 LOYIHA XARITASI (2.236.0, backend docs/knowledge/205): mijoz bilan bir xil joyni ko'rib gaplashish uchun
// etaplar (ustun) × rollar (qator) taxtasi. Har kartochka = ilovaning bir joyi: oxirgi sinov rasmlari (agent sinovi
// `map_mark` bilan o'zi ilib qo'yadi), u yerga yetib borish yo'li, holat va «➕ Shu joyga vazifa».
// Xarita AI qoralamasi (rejalar + sinov ssenariylari + modullar) bilan tuziladi, keyin qo'lda tahrirlanadi.
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';

const ST = {
  ok: { dot: 'bg-emerald-500', label: "Sinovdan o'tgan" },
  issue: { dot: 'bg-rose-500', label: 'Muammo bor' },
  wip: { dot: 'bg-amber-400', label: 'Vazifa jarayonda' },
  none: { dot: 'bg-gray-300 dark:bg-gray-600', label: 'Sinalmagan' },
};
const mmss = (t) => { const x = Math.max(0, Math.floor(Number(t) || 0)); return `${Math.floor(x / 60)}:${String(x % 60).padStart(2, '0')}`; };
const fmt = (d) => { if (!d) return ''; const x = new Date(d); const p = (n) => String(n).padStart(2, '0'); return `${p(x.getDate())}.${p(x.getMonth() + 1)} ${p(x.getHours())}:${p(x.getMinutes())}`; };
const inp = 'w-full px-2.5 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white';
const btn = 'px-3 py-1.5 text-sm rounded-lg font-medium transition disabled:opacity-50';
const btnGray = `${btn} bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-100 hover:bg-gray-200 dark:hover:bg-gray-600`;
const btnBlue = `${btn} bg-primary-700 dark:bg-primary-600 text-white hover:bg-primary-800`;
const btnOn = '!bg-primary-100 dark:!bg-primary-900/60 !text-primary-800 dark:!text-primary-200';
const btnSm = '!px-2.5 !py-1';
// Joyida turadigan etaplar qatori va rollar ustuni — yumshoq (ko'zni charchatmaydigan) fon; tanlangan/sichqoncha
// ustidagi kartochkaning etapi va roli «qayerdaman» uchun yorqinroq.
const HEAD = 'bg-slate-100 dark:bg-slate-800 text-slate-700 dark:text-slate-200';
const HEAD_ON = 'bg-primary-50 dark:bg-slate-700 text-primary-800 dark:text-white shadow-[inset_0_-2px_0_0_rgb(96_165_250/0.7)]';
const ST_ORDER = ['ok', 'issue', 'wip', 'none'];
const lsOn = (k) => { try { return localStorage.getItem(k) === '1'; } catch (e) { return false; } };
const lsPut = (k, v) => { try { localStorage.setItem(k, v ? '1' : '0'); } catch (e) { } };

export default function ProjectMapPanel({ authFetch, apiUrl, projectId, toast, role = null, onAskAgent = null }) {
  // 👥 Rol (backend docs/knowledge/207): xaritani tuzish/tahrirlash — ish rollari; 🤝 mijoz faqat ko'radi va
  // «Shu joyga vazifa» qoldiradi (operator ruxsatidan keyin boshlanadi); 👁 kuzatuvchi faqat ko'radi.
  const canEdit = !role || ['owner', 'developer', 'reviewer'].includes(role);
  const isClient = role === 'client';
  const canTask = canEdit || isClient;
  // 🧠 Agent bilan maslahat: App beradi faqat 🧠 Loyiha agenti ochiq bo'lsa (egasi/dasturchi, ui_access yopmagan).
  const agentOk = !!onAskAgent && !isClient;
  const [data, setData] = useState(null);       // {map, nodes, job, modules}
  const [err, setErr] = useState('');
  const [sel, setSel] = useState(null);          // tanlangan kartochka id
  const [edit, setEdit] = useState(null);        // tahrirlanayotgan kartochka (forma)
  const [taskText, setTaskText] = useState('');
  const [busy, setBusy] = useState(false);
  const [lightbox, setLightbox] = useState(null);
  const [q, setQ] = useState('');
  const [player, setPlayer] = useState(null);     // 🎥 {url, t} — panel ichidagi video lahza
  const [rec, setRec] = useState(null);           // 🎬 etapni videoga olish oynasi {stage, mobileModuleId, webModuleId, narrate}
  const [hideEmpty, setHideEmpty] = useState(() => lsOn('kh_map_hide_empty'));   // kartochkasi yo'q etap/rollar yashirin
  const [compact, setCompact] = useState(() => lsOn('kh_map_compact'));           // kartochkada faqat nom
  const [hover, setHover] = useState(null);       // {stage, lane} — sichqoncha ustidagi kartochka (qayerdaman belgisi)
  const [boardH, setBoardH] = useState(null);     // taxta balandligi: ekran pastigacha (o'z oynasida suriladi)
  const [big, setBig] = useState(false);          // ⛶ katta ekran: xarita Studio'ni yopib butun oynani oladi
  const [menu, setMenu] = useState(false);        // ⋯ boshqarish menyusi (kartochka, rasmlarni ulash, qayta tuzish)
  const [seenJob, setSeenJob] = useState(() => { try { return localStorage.getItem('kh_map_job_seen') || ''; } catch (e) { return ''; } });
  // 📸 Bo'shlarni to'ldirish (backend services/mapFill.js): tugagan navbat qatori yopilgani (id) va «yetib bo'lmadi» ro'yxati ochiqmi.
  const [fillSeen, setFillSeen] = useState(() => { try { return localStorage.getItem('kh_map_fill_seen') || ''; } catch (e) { return ''; } });
  const [fillOpen, setFillOpen] = useState(false);
  // 🧷 Test holati nuqtalari (backend services/testState.js, docs/knowledge/211): test bazasi + fayllar + yon servislar «save»lari —
  // istalgan qadamdan oldingi holatga ~1 daqiqada qaytish. Faqat ish rollariga (mijoz/kuzatuvchiga emas).
  const [ts, setTs] = useState(null);            // {items, op, last, modules, busy}
  const [tsOpen, setTsOpen] = useState(false);
  const tsPollRef = useRef(null);
  const tsPrevOp = useRef(null);
  // 📌 Jarayonlar paneli yonga qadalgan bo'lsa (App: html.kh-docked, --kh-dock-w) — katta ekran uni yopmasin.
  const [docked, setDocked] = useState(() => document.documentElement.classList.contains('kh-docked'));
  const boardRef = useRef(null);
  const rootRef = useRef(null);
  const menuRef = useRef(null);
  const pollRef = useRef(null);
  // authFetch App'ning har renderida yangi funksiya — unga bog'lansak har render (masalan token hisoblagichi) xaritani
  // qayta yuklab tanlangan kartochkani yopardi. Shuning uchun ref orqali.
  const fetchRef = useRef(authFetch);
  fetchRef.current = authFetch;
  const say = (m, kind) => { if (toast) (kind === 'error' ? toast.error : toast)(m); };
  const media = (u) => (u && u.startsWith('/') ? `${apiUrl}${u}` : u);   // /media/... API hostida

  const load = useCallback(async () => {
    if (!projectId) return;
    try {
      const r = await fetchRef.current(`${apiUrl}/project-maps/${projectId}`);
      const d = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(d.error || 'Xarita yuklanmadi');
      setData(d); setErr('');
    } catch (e) { setErr(e.message); }
  }, [apiUrl, projectId]);

  useEffect(() => { setData(null); setSel(null); setEdit(null); load(); }, [load]);
  // Fon ishi (AI qoralama / rasmlarni ulash) ketayotganda 5 s da yangilanadi.
  useEffect(() => {
    clearInterval(pollRef.current);
    if (data && data.job && data.job.status === 'running') pollRef.current = setInterval(load, 5000);
    else if (data && data.map && data.map.fill && data.map.fill.status === 'running') pollRef.current = setInterval(load, 15000);   // 📸 navbat
    return () => clearInterval(pollRef.current);
  }, [data, load]);

  const tsOk = canEdit && !isClient;
  const loadTs = useCallback(async () => {
    if (!projectId || !tsOk) return;
    try {
      const r = await fetchRef.current(`${apiUrl}/test-state/${projectId}`);
      const d = await r.json().catch(() => ({}));
      if (!r.ok) return;
      setTs(d);
      // Fonda ketgan saqlash/tiklash tugadi — natijasi bir marta aytiladi.
      if (tsPrevOp.current && !d.op && d.last) {
        const l = d.last;
        say(l.ok ? `🧷 ${l.summary || `«${l.label}» ${l.kind === 'save' ? 'saqlandi' : 'tiklandi'}`}` : `🧷 «${l.label}»: ${l.error}`, l.ok ? null : 'error');
      }
      tsPrevOp.current = d.op || null;
    } catch (e) { }
  }, [apiUrl, projectId, tsOk]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { setTs(null); tsPrevOp.current = null; loadTs(); }, [loadTs]);
  useEffect(() => {
    clearInterval(tsPollRef.current);
    if (ts && ts.op) tsPollRef.current = setInterval(loadTs, 4000);
    else if (tsOpen) tsPollRef.current = setInterval(loadTs, 20000);
    return () => clearInterval(tsPollRef.current);
  }, [ts, tsOpen, loadTs]);

  // Taxta o'z oynasida ham yon tomonga, ham pastga suriladi — shunda etaplar qatori tepada, rollar ustuni chapda
  // qotib turadi (sahifa surilsa sticky ushlanmasdi). Balandlik = taxta tepasidan ekran pastigacha. Faqat oyna
  // o'lchamiga bog'lansa yetmasdi: ⏳ Jarayonlar paneli ochilganda Studio tablari 3 qatorga o'ralib taxtani pastga
  // surardi va pastki qismi ekrandan chiqib qolardi — endi panel kengligi o'zgarsa, tashqi oyna surilsa ham qayta o'lchanadi.
  useEffect(() => {
    let raf = 0;
    const fit = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const el = boardRef.current;
        if (!el) return;
        const top = Math.max(0, el.getBoundingClientRect().top);
        setBoardH(Math.max(280, Math.round(window.innerHeight - top - (big ? 12 : 16))));
      });
    };
    fit();
    window.addEventListener('resize', fit);
    window.addEventListener('scroll', fit, true);
    const ro = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(fit) : null;
    if (ro && rootRef.current) ro.observe(rootRef.current);
    return () => { cancelAnimationFrame(raf); window.removeEventListener('resize', fit); window.removeEventListener('scroll', fit, true); if (ro) ro.disconnect(); };
  }, [data, big]);
  useEffect(() => {
    const el = document.documentElement;
    const mo = new MutationObserver(() => setDocked(el.classList.contains('kh-docked')));
    mo.observe(el, { attributes: true, attributeFilter: ['class'] });
    return () => mo.disconnect();
  }, []);
  // ⋯ menyu tashqarisiga bosilsa yopiladi.
  useEffect(() => {
    if (!menu) return undefined;
    const off = (e) => { if (menuRef.current && !menuRef.current.contains(e.target)) setMenu(false); };
    document.addEventListener('mousedown', off);
    return () => document.removeEventListener('mousedown', off);
  }, [menu]);
  const exitBig = () => {
    setBig(false);
    try { if (document.fullscreenElement) document.exitFullscreen(); } catch (e) { }
  };
  // 🖥 Brauzerning haqiqiy to'liq ekrani (uchrashuvda mijozga ko'rsatish) — faqat katta ekran ichidan; Esc'ni brauzer o'zi oladi.
  const browserFull = () => {
    const el = rootRef.current;
    try { if (document.fullscreenElement) document.exitFullscreen(); else if (el && el.requestFullscreen) el.requestFullscreen(); } catch (e) { }
  };
  // Esc — eng ustidagini yopadi (rasm → video oynasi → tanlangan kartochka → katta ekran); tahrir formasi Esc bilan yo'qolmaydi.
  useEffect(() => {
    const onKey = (e) => {
      if (e.key !== 'Escape') return;
      if (lightbox) setLightbox(null); else if (rec) setRec(null); else if (menu) setMenu(false);
      else if (sel && !edit) setSel(null); else if (big && !edit) exitBig();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [lightbox, rec, edit, sel, big, menu]); // eslint-disable-line react-hooks/exhaustive-deps

  const call = async (method, path, body, okMsg) => {
    setBusy(true);
    try {
      const r = await fetchRef.current(`${apiUrl}${path}`, { method, headers: { 'Content-Type': 'application/json' }, body: body ? JSON.stringify(body) : undefined });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(d.error || 'Xato');
      if (okMsg) say(okMsg);
      await load();
      return d;
    } catch (e) { say(e.message, 'error'); return null; } finally { setBusy(false); }
  };

  const map = data && data.map;
  const nodes = useMemo(() => (data && data.nodes) || [], [data]);
  const stages = (map && map.stages) || [];
  const lanes = (map && map.lanes) || [];
  const node = nodes.find(n => n.id === sel) || null;
  const qq = q.trim().toLowerCase();
  const match = (n) => !qq || `${n.title} ${n.path_text || ''} ${n.module_name || ''}`.toLowerCase().includes(qq);
  const job = data && data.job;

  if (!projectId) return <div className="p-6 text-sm text-gray-500">Avval loyihani tanlang.</div>;
  if (err && !data) return <div className="p-6 text-sm text-rose-600">{err}</div>;
  if (!data) return <div className="p-6 text-sm text-gray-500">Yuklanmoqda…</div>;

  const jobBar = job && job.status === 'done' && job.detail ? (String(job.id) === seenJob ? null : (
    <div className="mb-2 text-xs text-emerald-700 dark:text-emerald-300 flex items-center gap-2">
      <span>✅ {job.title ? job.title.replace(/^\S+\s/, '').replace(/moqda$/, 'di') : 'Tayyor'}: {job.detail}</span>
      <button type="button" className="text-gray-400 hover:text-gray-700 dark:hover:text-white" title="Yopish"
        onClick={() => { const v = String(job.id); setSeenJob(v); try { localStorage.setItem('kh_map_job_seen', v); } catch (e) { } }}>✕</button>
    </div>
  )) : job && (job.status === 'running' || job.status === 'error') && (
    <div className={`mb-3 text-sm rounded-lg px-3 py-2 ${job.status === 'error' ? 'bg-rose-50 dark:bg-rose-900/30 text-rose-700 dark:text-rose-300' : 'bg-sky-50 dark:bg-sky-900/30 text-sky-800 dark:text-sky-200'}`}>
      {job.status === 'running' ? `⏳ ${job.title || 'Ishlanmoqda'}… ${job.progress || ''}` : `⚠️ ${job.title || 'Ish'}: ${job.error || 'xato'}`}
    </div>
  );

  if (!map) {
    return (
      <div className="p-6 max-w-2xl">
        {jobBar}
        <h2 className="text-lg font-semibold text-gray-900 dark:text-white">🗺 Loyiha xaritasi</h2>
        <p className="mt-2 text-sm text-gray-600 dark:text-gray-300">
          Mijoz bilan bir xil joyni ko'rib gaplashish uchun: ustunlar — etaplar, qatorlar — rollar, har kartochka — ilovaning bir joyi
          (rasmlar, u yerga yetib borish yo'li, holat, «Shu joyga vazifa»). Qoralamani AI sizning rejalaringiz, agent sinovlari
          ssenariylari va modullardan tuzadi — keyin tahrirlaysiz.
        </p>
        {canEdit ? (
        <button className={`${btnBlue} mt-4`} disabled={busy || (job && job.status === 'running')}
          onClick={() => call('POST', `/project-maps/${projectId}/draft`, {}, '🤖 Xarita tuzilmoqda — 1–3 daqiqa')}>
          🤖 Xaritani tuzish
        </button>
        ) : <p className="mt-4 text-sm text-gray-500 dark:text-gray-400">Xarita hali tayyorlanmagan.</p>}
      </div>
    );
  }

  const cellNodes = (lane, stage) => nodes.filter(n => n.lane_key === lane && n.stage_key === stage).sort((a, b) => (a.sort || 0) - (b.sort || 0));
  const openEdit = (n) => setEdit(n ? { ...n } : { id: null, title: '', stage_key: stages[0] && stages[0].key, lane_key: lanes[0] && lanes[0].key, module_id: '', path_text: '', web_path: '' });
  const saveEdit = async () => {
    const e = edit;
    if (!e.title.trim()) { say('Nom kerak', 'error'); return; }
    const body = { title: e.title, stage_key: e.stage_key, lane_key: e.lane_key, module_id: e.module_id || null, path_text: e.path_text, web_path: e.web_path };
    const d = e.id ? await call('PATCH', `/project-maps/nodes/${e.id}`, body, 'Saqlandi') : await call('POST', `/project-maps/${projectId}/nodes`, body, "Kartochka qo'shildi");
    if (d) { setEdit(null); if (d.id) setSel(d.id); }
  };
  // 🎬 Etapdagi kartochkalar qaysi ilovada ko'p bo'lsa — shu ilova oldindan tanlanadi (bitta sinov = bitta mobil ilova + web).
  const openRec = (stage) => {
    const mods = data.modules || [];
    const top = (type) => {
      const cnt = {};
      nodes.filter(n => n.stage_key === stage.key && n.module_id).forEach(n => { const m = mods.find(x => x.id === n.module_id); if (m && m.module_type === type && (type !== 'web' || m.test_url)) cnt[m.id] = (cnt[m.id] || 0) + 1; });
      const best = Object.entries(cnt).sort((a, b) => b[1] - a[1])[0];
      return best ? Number(best[0]) : '';
    };
    setRec({ stage, mobileModuleId: top('mobile'), webModuleId: top('web'), narrate: true });
  };
  // Videoga kiradiganlar: tanlangan ilova/web kartochkalari (+ ilovasi ko'rsatilmaganlar). Tanlangan ilovaning o'zinikisi bo'lmasa — 0.
  const recCount = (r) => {
    const st = nodes.filter(n => n.stage_key === r.stage.key);
    const own = st.filter(n => n.module_id && (n.module_id === Number(r.mobileModuleId) || n.module_id === Number(r.webModuleId)));
    return own.length ? own.length + st.filter(n => !n.module_id).length : 0;
  };
  const startRec = async () => {
    const r = rec;
    const d = await call('POST', `/project-maps/${projectId}/record`, { stageKey: r.stage.key, mobileModuleId: r.mobileModuleId || null, webModuleId: r.webModuleId || null, narrate: r.narrate }, null);
    if (d && d.ok) { say(`🎬 «${r.stage.title}» videoga olinmoqda — 🤖 Agent sinovi panelida jonli ko'rasiz; tayyor bo'lgach kartochkalarda 🎥 chiqadi${d.skipped ? ` (${d.skipped} ta kartochka boshqa ilovada — bu videoda yo'q)` : ''}`); setRec(null); }
  };
  const copyMoment = async (m) => {
    const link = `${apiUrl}${m.url}#t=${Math.floor(m.t)}`;
    try { await navigator.clipboard.writeText(link); say('🔗 Havola nusxalandi — mijozga yuborsangiz video shu joydan ochiladi'); } catch (e) { window.prompt('Havola:', link); }
  };
  const webUrl = (n) => {
    const m = (data.modules || []).find(x => x.id === n.module_id);
    if (!m || !m.test_url) return null;
    return m.test_url.replace(/\/+$/, '') + (n.web_path ? (n.web_path.startsWith('/') ? n.web_path : '/' + n.web_path) : '');
  };
  // 🧠 «Agent bilan maslahat» (backend 205): vazifani darhol bermay, joy konteksti (etap/rol/joy, modul, yo'l, sahifa, oxirgi
  // sinov) + so'rov + oxirgi 2 rasm 🧠 Loyiha agentiga yuboriladi (⏳ Jarayonlar → 🧠 Agent). Agent avval tushunganini,
  // savollarini va yechim taklifini aytadi; kelishilgach `create_task {map_node_id}` — vazifa shu kartochkaga bog'lanadi.
  const askAgent = (n, override = null) => {
    const text = (override != null ? override : taskText).trim();
    if (!text || !onAskAgent) return;
    const mod = (data.modules || []).find(x => x.id === n.module_id);
    const url = webUrl(n);
    const msg = [
      `[XARITA — ${(stages.find(s => s.key === n.stage_key) || {}).title || n.stage_key} → ${(lanes.find(l => l.key === n.lane_key) || {}).title || n.lane_key} → ${n.title}] (kartochka #${n.id})`,
      mod ? `Ilova/modul: ${mod.name} (${mod.module_type})` : '',
      n.path_text ? `Yo'l: ${n.path_text}` : '',
      url ? `Test sahifasi: ${url}` : '',
      n.last_at ? `Oxirgi sinov ${fmt(n.last_at)}${n.state === 'issue' ? ' — muammo' : ''}${n.last_note ? `: ${n.last_note}` : ''}` : '',
    ].filter(Boolean).join('\n') + `\n\n${text}\n\nVazifa berishdan oldin maslahatlashaylik: qanday tushundingiz, nimani aniqlashtirish kerak va qanday yechim taklif qilasiz?`;
    const images = (n.evidence || []).slice(0, 2).map(ev => ({ url: ev.url, name: `xarita: ${n.title}` }));
    try { if (document.fullscreenElement) document.exitFullscreen(); } catch (e) { }   // 🖥 to'liq ekranda Agent paneli ko'rinmaydi
    onAskAgent({ text: msg, attachments: { images, files: [] }, send: true, projectId });
    if (override == null) setTaskText('');
    say("🧠 Agentga yuborildi — javobi o'ngdagi ⏳ Jarayonlar → 🧠 Agent oynasida");
  };

  // 📸 Bo'shlarni to'ldirish (backend 205, services/mapFill.js): rasmi yo'q kartochkalar ilova bo'yicha 8 tadan navbat bilan agent
  // sinoviga beriladi (video yo'q); agent yo'lda uchragan boshqa kartochkalarni ham belgilaydi. Muammo → kartochka qizil, quyidagi
  // 🐞 blokda operator rasmni ko'rib tuzatishga beradi yoki «muammo emas» deydi.
  const modById = Object.fromEntries((data.modules || []).map(m => [m.id, m]));
  const canShoot = (n) => { const m = modById[n.module_id]; return !!m && (m.module_type === 'mobile' || (m.module_type === 'web' && !!m.test_url)); };
  const emptyOf = (stageKey) => nodes.filter(n => !n.shot_count && canShoot(n) && (!stageKey || n.stage_key === stageKey));
  const fill = map.fill || null;
  const fillOn = !!(fill && fill.status === 'running');
  const startFill = async (stage) => {
    const list = emptyOf(stage && stage.key);
    if (!list.length) return;
    const by = {};
    list.forEach(n => { const m = modById[n.module_id]; by[m.name] = (by[m.name] || 0) + 1; });
    const runs = Object.values(by).reduce((a, c) => a + Math.ceil(c / 8), 0);
    if (!window.confirm(`📸 ${stage ? `«${stage.title}» etapidagi` : 'Xaritadagi'} ${list.length} ta bo'sh joy agent sinovi bilan rasmga olinsinmi?\n\n`
      + Object.entries(by).map(([k, v]) => `• ${k}: ${v}`).join('\n')
      + `\n\nIlova bo'yicha 8 tadan, navbat bilan ~${runs} ta sinov (har biri 10–30 daqiqa, emulatorni band qiladi). Agent yo'lda uchragan boshqa joylarni ham belgilaydi. Muammo bo'lsa kartochka qizil bo'ladi — rasmni ko'rib tuzatishga o'zingiz berasiz.`)) return;
    const d = await call('POST', `/project-maps/${projectId}/fill`, { stageKey: stage ? stage.key : null }, null);
    if (d && d.ok) say(`📸 Boshlandi: ${d.total} ta joy navbatda${d.skipped ? ` (${d.skipped} ta kartochkaga agent yeta olmaydi — ilovasi belgilanmagan)` : ''}. Har sinov 🧪 Sinov panelida jonli ko'rinadi`);
  };
  const stopFill = async () => { if (window.confirm("📸 Xarita to'ldirish to'xtatilsinmi? Ketayotgan sinov ham to'xtaydi.")) await call('DELETE', `/project-maps/${projectId}/fill`, null, "⏹ To'xtatildi"); };
  const focusNode = (n) => {
    if (!n) return;
    setSel(n.id); setTaskText('');
    setTimeout(() => { const el = boardRef.current && boardRef.current.querySelector(`[data-node="${n.id}"]`); if (el) el.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' }); }, 40);
  };
  const issueNodes = nodes.filter(n => n.state === 'issue');
  const nextIssue = () => { if (!issueNodes.length) return; const i = issueNodes.findIndex(n => n.id === sel); focusNode(issueNodes[(i + 1) % issueNodes.length]); };
  const issueText = (n) => `Sinovda topilgan muammoni tuzating: ${n.last_note || "agent bu joyni muammo deb belgiladi — ilova qilingan rasmga qarang"}`;
  const fixIssue = async (n) => { const d = await call('POST', `/project-maps/nodes/${n.id}/task`, { text: issueText(n) }, null); if (d && d.taskId) say(`🛠 Vazifa #${d.taskId} yaratildi — tuzatilguncha kartochka sariq`); };
  const dismissIssue = (n) => call('POST', `/project-maps/nodes/${n.id}/dismiss-issue`, {}, '✖ Muammo emas — kartochka yashilga qaytdi');
  // 🧷 Test holati amallari — natija fonda; panel 4 s da yangilanib tugaganini aytadi.
  const tsCall = async (method, path, body) => {
    try {
      const r = await fetchRef.current(`${apiUrl}${path}`, { method, headers: { 'Content-Type': 'application/json' }, body: body ? JSON.stringify(body) : undefined });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) { const e = new Error(d.error || 'Xato'); e.status = r.status; throw e; }
      return d;
    } finally { loadTs(); }
  };
  const tsSave = async (label, mapNodeId = null) => {
    const name = window.prompt("🧷 Hozirgi test muhiti holati qanday nom bilan saqlansin? (qaysi qadamdan keyingi holat: «6 — Korxona yaratildi»)", label || '');
    if (name == null || !name.trim()) return;
    try { await tsCall('POST', `/test-state/${projectId}/save`, { label: name.trim(), mapNodeId }); say(`🧷 «${name.trim()}» saqlanmoqda…`); setTsOpen(true); }
    catch (e) { say(e.message, 'error'); }
  };
  const tsRestore = async (c) => {
    const days = c.age_days || 0;
    if (!window.confirm(`🧷 Test muhiti «${c.label}» (${fmt(c.created_at)}) holatiga qaytarilsinmi?\n\n`
      + `• Hozirgi holat avval «⟲ … oldidan» nuqtasiga saqlanadi — kerak bo'lsa unga qaytasiz.\n`
      + `• Test ilovasi ~1 daqiqa to'xtaydi; baza, yuklangan fayllar va test Traccar nuqtadagidek bo'ladi.\n`
      + (days ? `• Sanalar +${days} kunga suriladi («bugungi» yozuvlar bugungi bo'lib qoladi).\n` : '')
      + `• Faqat TEST muhiti — production'ga tegilmaydi.`)) return;
    const go = async (force) => { await tsCall('POST', `/test-state/${projectId}/restore`, { checkpointId: c.id, force }); say(`🧷 «${c.label}» tiklanmoqda — ~1 daqiqa`); setTsOpen(true); };
    try { await go(false); }
    catch (e) {
      if (e.status === 409 && /dasturchi agent/.test(e.message) && window.confirm(`${e.message}\n\nBaribir tiklaysizmi? Agent ishlayotgan vazifaning test muhitidagi sinovi buzilishi mumkin.`)) {
        try { await go(true); } catch (e2) { say(e2.message, 'error'); }
      } else say(e.message, 'error');
    }
  };
  const tsPin = async (c) => { try { await tsCall('PATCH', `/test-state/checkpoints/${c.id}`, { pinned: !c.pinned }); } catch (e) { say(e.message, 'error'); } };
  const tsRename = async (c) => {
    const v = window.prompt('Yangi nom', c.label);
    if (v == null || !v.trim() || v.trim() === c.label) return;
    try { await tsCall('PATCH', `/test-state/checkpoints/${c.id}`, { label: v.trim() }); } catch (e) { say(e.message, 'error'); }
  };
  const tsDelete = async (c) => {
    if (!window.confirm(`«${c.label}» nuqtasi o'chirilsinmi? Bu holatga endi qaytib bo'lmaydi.`)) return;
    try { await tsCall('DELETE', `/test-state/checkpoints/${c.id}`); say("🗑 O'chirildi"); } catch (e) { say(e.message, 'error'); }
  };
  const tsItems = (ts && ts.items) || [];
  const tsReady = tsItems.filter(c => c.status === 'ready');
  const tsMods = ((ts && ts.modules) || []).filter(m => m.supported);
  const TS_SRC = { auto: ['🤖', "Nazoratchi sinovi o'tgandan keyin o'zi saqlagan"], manual: ['✋', "Qo'lda saqlangan"], agent: ['🧠', 'Agent saqlagan'], pre_restore: ['⟲', "Tiklashdan oldin o'zi saqlangan (orqaga qaytish uchun)"] };
  const tsBar = tsOk && tsOpen && ts ? (
    <div className="mb-2 text-xs rounded-lg px-3 py-2 bg-violet-50 dark:bg-violet-900/25 text-violet-950 dark:text-violet-100">
      <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
        <span className="font-semibold">🧷 Test holati nuqtalari</span>
        {tsMods.length > 0 && <span className="opacity-75" translate="no">{tsMods.map(m => `${m.name}: baza${(m.media || []).length ? ' + ' + m.media.join(', ') : ''}${(m.extras || []).length ? ' + ' + m.extras.join(', ') : ''}`).join(' · ')}</span>}
        <span className="ml-auto flex items-center gap-2">
          <button type="button" className={`${btnGray} ${btnSm} !text-xs`} disabled={!!ts.op || !tsMods.length} onClick={() => tsSave('')}
            title="Hozirgi test muhitini (baza + yuklangan fayllar + yon servislar) nom bilan saqlash">💾 Hozirgi holatni saqlash</button>
          <button type="button" className="text-gray-400 hover:text-gray-700 dark:hover:text-white" title="Yopish" onClick={() => setTsOpen(false)}>✕</button>
        </span>
      </div>
      {ts.op ? <div className="mt-1">⏳ {ts.op.kind === 'restore' ? 'Tiklanmoqda' : 'Saqlanmoqda'}: «<span translate="no">{ts.op.label}</span>» — {ts.op.step} · {ts.op.seconds} s</div>
        : ts.last ? <div className={`mt-1 ${ts.last.ok ? '' : 'text-rose-700 dark:text-rose-300'}`} translate="no">{ts.last.ok ? '✅' : '❌'} {ts.last.ok ? (ts.last.summary || `«${ts.last.label}» ${ts.last.kind === 'save' ? 'saqlandi' : 'tiklandi'}`) : `«${ts.last.label}»: ${ts.last.error}`}</div> : null}
      {!ts.op && ts.busy && <div className="mt-1 opacity-80">⏸ Hozir tiklab bo'lmaydi: {ts.busy}</div>}
      {!tsMods.length && <div className="mt-1 opacity-80">Bu loyihada holati saqlanadigan test bazasi yo'q (test muhitida PostgreSQL yoki MySQL kerak).</div>}
      {tsItems.length > 0 ? (
        <ul className="mt-1.5 max-h-60 overflow-auto space-y-1 border-t border-black/10 dark:border-white/10 pt-1.5">
          {tsItems.map(c => {
            const nd = c.map_node_id ? nodes.find(n => n.id === c.map_node_id) : null;
            const src = TS_SRC[c.source] || ['•', c.source];
            return (
              <li key={c.id} className="flex flex-wrap items-center gap-x-2 gap-y-0.5 leading-snug">
                <span title={src[1]}>{src[0]}</span>
                <span className="font-medium" translate="no" title={c.note || ''}>{c.label}</span>
                {nd && <button type="button" className="underline decoration-dotted hover:opacity-80" translate="no" onClick={() => focusNode(nd)} title="Xaritadagi kartochka">🗺 {nd.title}</button>}
                <span className="opacity-70" translate="no">{fmt(c.created_at)}{c.age_days ? ` · ${c.age_days} kun oldin` : ''} · {((c.bytes || 0) / 1048576).toFixed(1)} MB{c.restore_count ? ` · ⟲ ${c.restore_count}` : ''}</span>
                {c.status === 'saving' && <span>⏳ saqlanmoqda</span>}
                {c.status === 'failed' && <span className="text-rose-700 dark:text-rose-300" translate="no">❌ {c.error || 'saqlanmadi'}</span>}
                <span className="ml-auto flex items-center gap-1">
                  {c.status === 'ready' && <button type="button" className={`${btnGray} !px-2 !py-0.5 !text-xs`} disabled={!!ts.op} onClick={() => tsRestore(c)}
                    title="Test muhitini shu holatga qaytarish (~1 daqiqa); hozirgi holat oldin saqlanadi">⟲ Tiklash</button>}
                  <button type="button" className="px-1 rounded hover:bg-black/5 dark:hover:bg-white/10" onClick={() => tsPin(c)}
                    title={c.pinned ? 'Qadashni olish' : "Qadash — avtomatik tozalashda o'chmaydi"}>{c.pinned ? '📌' : '📍'}</button>
                  <button type="button" className="px-1 rounded hover:bg-black/5 dark:hover:bg-white/10" onClick={() => tsRename(c)} title="Nomini o'zgartirish">✏️</button>
                  <button type="button" className="px-1 rounded hover:bg-black/5 dark:hover:bg-white/10" disabled={!!ts.op} onClick={() => tsDelete(c)} title="O'chirish">🗑</button>
                </span>
              </li>
            );
          })}
        </ul>
      ) : tsMods.length > 0 && <div className="mt-1 opacity-80">Hali nuqta yo'q — «💾 Hozirgi holatni saqlash» yoki Nazoratchi sinovi o'tganda o'zi saqlanadi.</div>}
      <div className="mt-1.5 opacity-70">Nazoratchi sinovi o'tganda holat sinov nomi bilan o'zi saqlanadi. «4-qadamni sina» desangiz, 🧠 agent 3-qadam nuqtasidan boshlaydi. Nuqtadan tiklashda sanalar bugunga suriladi.</div>
    </div>
  ) : null;

  // 🤝 Mijozga navbat qatori (yetib bo'lmagan joylar sabablari — ichki) ko'rsatilmaydi.
  const fillBar = fill && !isClient && (fillOn || String(fill.id) !== fillSeen) ? (() => {
    const want = new Set(fill.targets || []);
    const filled = nodes.filter(n => want.has(n.node_key) && n.shot_count).length;
    const runsL = fill.runs || [];
    const iss = runsL.reduce((a, r) => a + (r.issues || 0), 0);
    const un = fill.unreached || [];
    const cur = fill.current;
    const mins = cur ? Math.max(1, Math.round((Date.now() - new Date(cur.startedAt).getTime()) / 60000)) : 0;
    const stT = fill.stageKey ? (stages.find(s => s.key === fill.stageKey) || {}).title : '';
    const linkB = 'underline decoration-dotted hover:opacity-80';
    return (
      <div className={`mb-2 text-xs rounded-lg px-3 py-2 ${fillOn ? 'bg-sky-50 dark:bg-sky-900/30 text-sky-900 dark:text-sky-100' : 'bg-emerald-50 dark:bg-emerald-900/25 text-emerald-900 dark:text-emerald-100'}`}>
        <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
          <span className="font-semibold">{fillOn ? "📸 Xarita to'ldirilmoqda" : fill.status === 'stopped' ? "⏹ To'ldirish to'xtatildi" : "✅ To'ldirish tugadi"}{stT ? ` · «${stT}»` : ''}</span>
          <span>{filled}/{fill.total} joy rasmga olindi{runsL.length ? ` · ${runsL.length} ta sinov` : ''}</span>
          {fillOn && (cur ? <span>hozir: {cur.moduleName}, {cur.keys.length} joy · {mins} daq</span>
            : fill.wait ? <span title={fill.wait.reason}>⏳ navbat kutyapti: {String(fill.wait.reason).slice(0, 90)}</span>
              : <span>keyingi sinov tayyorlanmoqda…</span>)}
          {iss > 0 && <button type="button" className={linkB} onClick={nextIssue} title="Muammo belgilangan kartochkalarni birma-bir ochadi">🐞 {iss} muammo</button>}
          {un.length > 0 && <button type="button" className={linkB} onClick={() => setFillOpen(v => !v)}>⚠️ {un.length} ta joyga yetib bo'lmadi {fillOpen ? '▴' : '▾'}</button>}
          {(fill.skipped || []).length > 0 && <span title={(fill.skipped || []).map(x => `${x.title} — ${x.why}`).join('\n')}>{fill.skipped.length} ta kartochkaga agent yeta olmaydi (ilovasi yo'q)</span>}
          <span className="ml-auto flex items-center gap-2">
            {fillOn && canEdit && <button type="button" className={`${btnGray} ${btnSm} !text-xs`} disabled={busy} onClick={stopFill}>⏹ To'xtatish</button>}
            {!fillOn && <button type="button" className="text-gray-400 hover:text-gray-700 dark:hover:text-white" title="Yopish"
              onClick={() => { const v = String(fill.id); setFillSeen(v); try { localStorage.setItem('kh_map_fill_seen', v); } catch (e) { } }}>✕</button>}
          </span>
        </div>
        {fillOpen && un.length > 0 && (
          <ul className="mt-1.5 max-h-44 overflow-auto space-y-1 border-t border-black/10 dark:border-white/10 pt-1.5">
            {un.map(u => (
              <li key={u.key} className="leading-snug">
                <button type="button" className={`${linkB} font-medium`} translate="no" onClick={() => focusNode(nodes.find(n => n.node_key === u.key))}>{u.title}</button>
                <span className="opacity-75" translate="no"> · {u.module} — {String(u.why || '').slice(0, 220)}</span>
              </li>
            ))}
          </ul>
        )}
      </div>
    );
  })() : null;

  // Etap hisobi (holatlar bo'yicha), bo'shlarni yashirish va «qayerdaman» — taxta uchun hisoblanadi.
  const stageStats = (key) => {
    const c = { ok: 0, issue: 0, wip: 0, none: 0 };
    nodes.forEach(n => { if (n.stage_key === key) c[ST[n.state] ? n.state : 'none'] += 1; });
    return c;
  };
  const visStages = hideEmpty ? stages.filter(s => nodes.some(n => n.stage_key === s.key)) : stages;
  const visLanes = hideEmpty ? lanes.filter(l => nodes.some(n => n.lane_key === l.key)) : lanes;
  const hiddenN = (stages.length - visStages.length) + (lanes.length - visLanes.length);
  const act = hover || (node ? { stage: node.stage_key, lane: node.lane_key } : null);
  const toggle = (k, v, set) => { set(v); lsPut(k, v); };

  const menuItem = 'w-full text-left px-3 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700 disabled:opacity-50 text-gray-800 dark:text-gray-100';
  return (
    <div ref={rootRef}
      className={big ? 'fixed top-16 left-0 bottom-0 z-[45] p-3 bg-gray-50 dark:bg-gray-900 border-t border-gray-200 dark:border-gray-700 shadow-2xl overflow-hidden' : 'p-4'}
      style={big ? { right: docked ? 'var(--kh-dock-w, 460px)' : 0 } : undefined}>
      {jobBar}
      <div className="flex flex-wrap items-center gap-2 mb-2">
        <h2 className="text-base font-semibold text-gray-900 dark:text-white truncate min-w-0 max-w-[26rem]" title={map.title || ''}>🗺 {map.title || 'Loyiha xaritasi'}</h2>
        <input value={q} onChange={e => setQ(e.target.value)} placeholder="Qidirish: SOS, tushlik…" className={`${inp} !w-44 !py-1`} />
        <button className={`${btnGray} ${btnSm} ${hideEmpty ? btnOn : ''}`} onClick={() => toggle('kh_map_hide_empty', !hideEmpty, setHideEmpty)}
          title="Kartochkasi yo'q etap va rollarni yashiradi — taxta ixchamlashadi">
          {hideEmpty ? `▦ Bo'shlar yashirin${hiddenN ? ` (${hiddenN})` : ''}` : "▦ Bo'shlarni yashirish"}
        </button>
        <button className={`${btnGray} ${btnSm} ${compact ? btnOn : ''}`} onClick={() => toggle('kh_map_compact', !compact, setCompact)}
          title="Kartochkada faqat nom — ekranga ko'proq joy sig'adi (to'liq nom sichqoncha ustida)">☰ Ixcham</button>
        <button className={`${btnGray} ${btnSm} ${big ? btnOn : ''}`} onClick={() => (big ? exitBig() : setBig(true))}
          title={big ? "Oddiy ko'rinishga qaytish (Esc)" : "Xarita Studio menyularini yopib butun oynani oladi — ⏳ Jarayonlar/🧠 Agent paneli yonda qoladi"}>
          {big ? '⤡ Kichraytirish' : '⛶ Katta ekran'}
        </button>
        {big && <button className={`${btnGray} ${btnSm}`} onClick={browserFull}
          title="Brauzerning to'liq ekrani — uchrashuvda mijozga ko'rsatish uchun (chiqish: Esc)">🖥 To'liq ekran</button>}
        {canEdit && !fillOn && emptyOf(null).length > 0 && (
          <button className={`${btnGray} ${btnSm}`} disabled={busy} onClick={() => startFill(null)}
            title="Rasmi yo'q kartochkalarni agent sinovlari navbat bilan rasmga oladi va tekshiradi (ilova bo'yicha 8 tadan, video yo'q); yo'lda uchragan boshqa joylarni ham belgilaydi">
            📸 Bo'shlarni to'ldirish ({emptyOf(null).length})
          </button>
        )}
        {issueNodes.length > 0 && (
          <button className={`${btnGray} ${btnSm} !text-rose-700 dark:!text-rose-300`} onClick={nextIssue}
            title="Sinovda muammo belgilangan kartochkalarni birma-bir ochadi — rasmni ko'rib tuzatishga berasiz yoki «muammo emas» deysiz">
            🐞 {issueNodes.length} muammo
          </button>
        )}
        {tsOk && (
          <button className={`${btnGray} ${btnSm} ${tsOpen ? btnOn : ''}`} onClick={() => { setTsOpen(v => !v); if (!tsOpen) loadTs(); }}
            title="Test muhitining saqlangan holatlari (o'yindagi save): istalgan qadamdan oldingi holatga ~1 daqiqada qaytish — 1 dan keyin 4-ni yoki 8 dan keyin 1-ni sinash uchun">
            🧷 Test holatlari{ts ? ` (${tsReady.length})` : ''}{ts && ts.op ? ' ⏳' : ''}
          </button>
        )}
        {canEdit && (
          <div className="relative" ref={menuRef}>
            <button className={`${btnGray} ${btnSm} ${menu ? btnOn : ''}`} onClick={() => setMenu(v => !v)} title="Kartochka qo'shish, sinov rasmlarini ulash, xaritani qayta tuzish">⋯ Boshqarish</button>
            {menu && (
              <div className="absolute left-0 top-full mt-1 z-[50] w-64 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 shadow-xl py-1">
                <button className={menuItem} disabled={busy} onClick={() => { setMenu(false); openEdit(null); }}>➕ Kartochka</button>
                <button className={menuItem} disabled={busy || (job && job.status === 'running')}
                  title="Oldingi agent sinovlarining rasmlarini (izohlari bo'yicha) mos kartochkalarga ulaydi"
                  onClick={() => { setMenu(false); call('POST', `/project-maps/${projectId}/link-shots`, {}, '🔗 Sinov rasmlari ulanmoqda'); }}>🔗 Sinov rasmlarini ulash</button>
                <button className={menuItem} disabled={busy || (job && job.status === 'running')}
                  title="Xaritani AI qaytadan tuzadi — qo'lda qo'shilgan kartochkalar va ilingan rasmlar saqlanadi"
                  onClick={() => { setMenu(false); if (window.confirm('Xarita AI bilan qayta tuzilsinmi? Qo\'lda kiritilgan kartochkalar va rasmlar saqlanadi.')) call('POST', `/project-maps/${projectId}/draft`, { refresh: true }, '🤖 Qayta tuzilmoqda'); }}>🤖 Qayta tuzish</button>
              </div>
            )}
          </div>
        )}
      </div>

      {fillBar}
      {tsBar}
      <div className="flex flex-col xl:flex-row gap-4 items-start">
        <div ref={boardRef} className="w-full xl:w-auto xl:flex-1 min-w-0 overflow-auto rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-gray-900"
          style={boardH ? { maxHeight: boardH } : undefined} onMouseLeave={() => setHover(null)}>
          <div className="grid" style={{ gridTemplateColumns: `190px repeat(${visStages.length}, minmax(${compact ? 150 : 180}px, 1fr))` }}>
            <div className={`sticky top-0 left-0 z-30 ${HEAD} border-b border-r border-slate-200 dark:border-slate-700 px-3 py-2 text-[10px] text-slate-500 dark:text-slate-400 flex flex-col justify-end gap-0.5`}>
              {Object.entries(ST).map(([k, v]) => <span key={k} className="flex items-center gap-1"><span className={`inline-block w-2 h-2 rounded-full ${v.dot}`} />{v.label}</span>)}
              <span className="mt-1 text-[11px] font-semibold">Rol ↓ · Etap →</span>
            </div>
            {visStages.map(s => {
              const c = stageStats(s.key);
              const tot = c.ok + c.issue + c.wip + c.none;
              const on = !!act && act.stage === s.key;
              return (
                <div key={s.key} className={`sticky top-0 z-20 ${on ? HEAD_ON : HEAD} border-b border-slate-200 dark:border-slate-700 px-2 py-2 transition-colors`} title={s.note || ''}>
                  <div className="flex items-start gap-1">
                    <span className="flex-1 text-xs font-semibold leading-snug">{stages.indexOf(s) + 1}. {s.title}</span>
                    {canEdit && !fillOn && emptyOf(s.key).length > 0 && <button type="button" onClick={() => startFill(s)}
                      title={`📸 Shu etapdagi ${emptyOf(s.key).length} ta bo'sh joyni agent sinovi bilan rasmga olish (video yo'q)`}
                      className="shrink-0 px-1 rounded hover:bg-slate-200 dark:hover:bg-slate-700">📸</button>}
                    {canEdit && <button type="button" onClick={() => openRec(s)} title="🎬 Shu etapni videoga olish — agent etap joylarini tartib bilan ko'rsatadi, video yoziladi va har kartochka videoning o'z lahzasiga bog'lanadi"
                      className="shrink-0 px-1 rounded hover:bg-slate-200 dark:hover:bg-slate-700">🎬</button>}
                  </div>
                  {tot > 0 && (<>
                    <div className="mt-1 flex items-center gap-2 text-[10px] text-slate-500 dark:text-slate-400" translate="no">
                      {ST_ORDER.filter(k => c[k]).map(k => (
                        <span key={k} className="inline-flex items-center gap-0.5" title={ST[k].label}><span className={`inline-block w-1.5 h-1.5 rounded-full ${ST[k].dot}`} />{c[k]}</span>
                      ))}
                    </div>
                    <div className="mt-1 h-1 rounded-full overflow-hidden flex bg-slate-200 dark:bg-slate-700" title={`${c.ok} / ${tot} sinovdan o'tgan`}>
                      {['ok', 'wip', 'issue'].map(k => c[k] ? <div key={k} className={ST[k].dot} style={{ width: `${(c[k] * 100) / tot}%` }} /> : null)}
                    </div>
                  </>)}
                </div>
              );
            })}
            {visLanes.map(l => {
              const on = !!act && act.lane === l.key;
              const ln = nodes.filter(n => n.lane_key === l.key);
              const okN = ln.filter(n => n.state === 'ok').length;
              return (
                <React.Fragment key={l.key}>
                  <div className={`sticky left-0 z-10 ${on ? HEAD_ON : HEAD} border-b border-r border-slate-200 dark:border-slate-700 px-3 py-2 transition-colors`} title={l.note || ''}>
                    <div className="text-xs font-semibold leading-snug break-words">{l.title}</div>
                    {ln.length > 0 && <div className="mt-0.5 text-[10px] text-slate-500 dark:text-slate-400">{okN}/{ln.length} sinovdan o'tgan</div>}
                  </div>
                  {visStages.map(s => {
                    const cross = !!act && (act.stage === s.key || act.lane === l.key);
                    return (
                      <div key={s.key} className={`border-b border-r border-slate-100 dark:border-slate-800 p-1.5 transition-colors ${cross ? 'bg-primary-50/60 dark:bg-slate-800/50' : ''}`}>
                        <div className={`${compact ? 'min-h-[36px]' : 'min-h-[48px]'} h-full rounded-lg border border-dashed border-gray-200 dark:border-gray-700/70 p-1 flex flex-col gap-1`}>
                          {cellNodes(l.key, s.key).map(n => (
                            <button key={n.id} type="button" data-node={n.id} onClick={() => { setSel(n.id); setTaskText(''); }}
                              onMouseEnter={() => setHover({ stage: n.stage_key, lane: n.lane_key })}
                              title={compact ? `${n.title}${n.module_name ? ' · ' + n.module_name : ''}` : undefined}
                              className={`text-left rounded-md border ${compact ? 'px-1.5 py-1' : 'px-2 py-1.5'} bg-white dark:bg-gray-800 transition ${sel === n.id ? 'border-primary-600 ring-2 ring-primary-500/40' : 'border-gray-200 dark:border-gray-700 hover:border-gray-400'} ${match(n) ? '' : 'opacity-30'}`}>
                              <div className="flex items-start gap-1.5 min-w-0">
                                <span className={`mt-1 shrink-0 inline-block w-2 h-2 rounded-full ${(ST[n.state] || ST.none).dot}`} />
                                <span className={`min-w-0 text-xs font-medium text-gray-900 dark:text-white leading-snug ${compact ? 'truncate' : ''}`} translate="no">{n.title}</span>
                              </div>
                              {!compact && (
                                <div className="mt-0.5 text-[11px] text-gray-500 dark:text-gray-400 truncate" translate="no">
                                  {n.module_name || '—'}{n.shot_count ? ` · 📸 ${n.shot_count}` : ''}{n.video_count ? ` · 🎥 ${n.video_count}` : ''}{n.task_count ? ` · 🛠 ${n.task_count}` : ''}
                                </div>
                              )}
                            </button>
                          ))}
                        </div>
                      </div>
                    );
                  })}
                </React.Fragment>
              );
            })}
          </div>
          {!nodes.length && <div className="p-4 text-sm text-gray-500">Kartochka yo'q — «➕ Kartochka» yoki «🤖 Qayta tuzish».</div>}
        </div>

        {(node || edit) && (
          <div className="w-full xl:w-[380px] shrink-0 rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 p-4 overflow-y-auto"
            style={boardH ? { maxHeight: boardH } : undefined}>
            {edit ? (
              <div className="space-y-2">
                <div className="font-semibold text-gray-900 dark:text-white">{edit.id ? '✏️ Kartochkani tahrirlash' : '➕ Yangi kartochka'}</div>
                <input className={inp} value={edit.title} onChange={e => setEdit({ ...edit, title: e.target.value })} placeholder="Joy nomi: SOS «Yo'l yopiq»" />
                <div className="grid grid-cols-2 gap-2">
                  <select className={inp} value={edit.stage_key || ''} onChange={e => setEdit({ ...edit, stage_key: e.target.value })}>
                    {stages.map(s => <option key={s.key} value={s.key}>{s.title}</option>)}
                  </select>
                  <select className={inp} value={edit.lane_key || ''} onChange={e => setEdit({ ...edit, lane_key: e.target.value })}>
                    {lanes.map(l => <option key={l.key} value={l.key}>{l.title}</option>)}
                  </select>
                </div>
                <select className={inp} value={edit.module_id || ''} onChange={e => setEdit({ ...edit, module_id: e.target.value ? Number(e.target.value) : '' })}>
                  <option value="">Ilova / modul tanlanmagan</option>
                  {(data.modules || []).map(m => <option key={m.id} value={m.id}>{m.name} ({m.module_type})</option>)}
                </select>
                <textarea className={inp} rows={4} value={edit.path_text || ''} onChange={e => setEdit({ ...edit, path_text: e.target.value })}
                  placeholder="U yerga yetib borish yo'li: kim bo'lib kiriladi → qaysi tugmalar → nima tayyor bo'lishi kerak" />
                <input className={inp} value={edit.web_path || ''} onChange={e => setEdit({ ...edit, web_path: e.target.value })} placeholder="Web sahifa yo'li (web modul uchun): /dispatcher/waybills" />
                <div className="flex gap-2 pt-1">
                  <button className={btnBlue} disabled={busy} onClick={saveEdit}>Saqlash</button>
                  <button className={btnGray} onClick={() => setEdit(null)}>Bekor qilish</button>
                  {edit.id && <button className={`${btnGray} ml-auto !text-rose-600`} disabled={busy}
                    onClick={async () => { if (window.confirm(`«${edit.title}» kartochkasi o'chirilsinmi? Ilingan rasmlar ham ajraladi.`)) { const d = await call('DELETE', `/project-maps/nodes/${edit.id}`, null, "O'chirildi"); if (d) { setEdit(null); setSel(null); } } }}>🗑</button>}
                </div>
              </div>
            ) : (
              <div>
                <div className="flex items-start gap-2">
                  <span className={`mt-1.5 shrink-0 inline-block w-2.5 h-2.5 rounded-full ${(ST[node.state] || ST.none).dot}`} title={(ST[node.state] || ST.none).label} />
                  <div className="min-w-0">
                    <div className="font-semibold text-gray-900 dark:text-white leading-snug" translate="no">{node.title}</div>
                    <div className="text-xs text-gray-500 dark:text-gray-400 mt-0.5" translate="no">
                      {(stages.find(s => s.key === node.stage_key) || {}).title} · {(lanes.find(l => l.key === node.lane_key) || {}).title}{node.module_name ? ` · ${node.module_name}` : ''}
                    </div>
                  </div>
                  {canEdit && <button className="ml-auto text-xs text-gray-500 hover:text-gray-800 dark:hover:text-white" onClick={() => openEdit(node)} title="Tahrirlash">✏️</button>}
                  <button className={`${canEdit ? '' : 'ml-auto '}text-xs text-gray-500 hover:text-gray-800 dark:hover:text-white`} onClick={() => setSel(null)} title="Yopish">✕</button>
                </div>
                {node.path_text && <div className="mt-3 text-sm text-gray-700 dark:text-gray-200 whitespace-pre-wrap" translate="no"><span className="text-xs font-semibold text-gray-500">Yo'l: </span>{node.path_text}</div>}
                {node.state === 'issue' ? (() => {
                  // 🐞 Sinovda muammo: operator rasmni ko'rib qaror qiladi — avtomatik tuzatishga ketmaydi.
                  const shot = (node.evidence || []).find(e => e.ok === 0);
                  return (
                    <div className="mt-3 rounded-lg border border-rose-200 dark:border-rose-800 bg-rose-50 dark:bg-rose-900/20 p-2.5">
                      <div className="text-xs font-semibold text-rose-700 dark:text-rose-300">🐞 Sinovda muammo{node.last_at ? ` · ${fmt(node.last_at)}` : ''}</div>
                      <div className="mt-1 text-sm text-rose-900 dark:text-rose-100 whitespace-pre-wrap" translate="no">{node.last_note || 'Agent bu joyni muammo deb belgiladi (izoh qoldirmagan)'}</div>
                      {shot && (
                        <button type="button" onClick={() => setLightbox(shot)} title="Kattalashtirish"
                          className="mt-2 block w-full rounded-md overflow-hidden border border-rose-200 dark:border-rose-800 bg-white dark:bg-gray-900">
                          <img src={media(shot.url)} alt="" className="w-full max-h-72 object-contain object-top" />
                        </button>
                      )}
                      {canEdit && (
                        <div className="mt-2 flex flex-wrap gap-1.5">
                          <button className={`${btnBlue} ${btnSm}`} disabled={busy} onClick={() => fixIssue(node)}
                            title="Rasmni ko'rdim, bu haqiqiy muammo — vazifa (joy, yo'l va shu rasm bilan) yaratiladi">🛠 Tuzatishga berish</button>
                          {agentOk && <button className={`${btnGray} ${btnSm}`} disabled={busy} onClick={() => askAgent(node, issueText(node))}
                            title="Avval agent bilan maslahatlashish — rasmni ko'rib sababini va yechimni aytadi, kelishgach vazifa beradi">🧠 Maslahat</button>}
                          <button className={`${btnGray} ${btnSm}`} disabled={busy} onClick={() => dismissIssue(node)}
                            title="Bu muammo emas (agent adashgan) — kartochka yashilga qaytadi, agent izohi saqlanadi">✖ Muammo emas</button>
                        </div>
                      )}
                    </div>
                  );
                })() : node.last_note && <div className="mt-2 text-xs rounded-lg px-2.5 py-1.5 bg-gray-50 dark:bg-gray-900/40 text-gray-600 dark:text-gray-300" translate="no">Oxirgi sinov {fmt(node.last_at)}: {node.last_note}</div>}

                <div className="mt-3">
                  <div className="text-xs font-semibold text-gray-500 mb-1.5">📸 Rasmlar {node.shot_count ? `(${node.shot_count})` : ''}</div>
                  {(node.evidence || []).length ? (
                    <div className="grid grid-cols-3 gap-1.5">
                      {node.evidence.map(ev => (
                        <button key={ev.id} type="button" onClick={() => setLightbox(ev)} className="relative rounded-md overflow-hidden border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-900" title={`${ev.surface || ''} · ${fmt(ev.created_at)}${ev.note ? ' · ' + ev.note : ''}`}>
                          <img src={media(ev.url)} alt="" loading="lazy" className="w-full h-24 object-cover object-top" />
                          <span className="absolute bottom-0 inset-x-0 text-[10px] bg-black/55 text-white px-1 truncate">{ev.surface === 'web' ? '🌐' : '📱'} {fmt(ev.created_at)}</span>
                        </button>
                      ))}
                    </div>
                  ) : <div className="text-xs text-gray-500">Hali rasm yo'q — agent sinovi shu joydan o'tganda o'zi qo'yadi.</div>}
                </div>

                {(node.moments || []).length > 0 && (
                  <div className="mt-3">
                    <div className="text-xs font-semibold text-gray-500 mb-1.5">🎥 Video lahzalari ({node.video_count})</div>
                    {player && player.url && node.moments.some(m => m.url === player.url) && (
                      <video key={`${player.url}#${player.t}`} src={`${media(player.url)}#t=${Math.floor(player.t)}`} controls autoPlay playsInline
                        onLoadedMetadata={(e) => { try { if (Math.abs(e.currentTarget.currentTime - player.t) > 1) e.currentTarget.currentTime = player.t; } catch (x) { } }}
                        className="w-full rounded-lg bg-black mb-1.5" />
                    )}
                    <div className="space-y-1">
                      {node.moments.map(m => (
                        <div key={m.id} className="flex items-center gap-2 text-xs">
                          <button type="button" className={`${btnGray} !px-2 !py-1 !text-xs`} onClick={() => setPlayer({ url: m.url, t: m.t })} title="Videoni shu joydan ko'rish">▶ {mmss(m.t)}</button>
                          <span className="text-gray-500 truncate flex-1" translate="no">{fmt(m.created_at)}{m.ok === 0 ? ' · ⚠️ muammo' : ''}{m.note ? ` · ${m.note}` : ''}</span>
                          <button type="button" className="text-gray-500 hover:text-gray-800 dark:hover:text-white" onClick={() => copyMoment(m)} title="Mijozga yuborish uchun havola (video shu joydan ochiladi)">🔗</button>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                <div className="mt-3 flex flex-wrap gap-2">
                  {webUrl(node) && <a className={btnGray} href={webUrl(node)} target="_blank" rel="noreferrer" title="Test muhitida shu sahifani yangi oynada ochadi">🌐 Ochish</a>}
                </div>

                {tsOk && ts && tsMods.length > 0 && (() => {
                  const mine = tsReady.filter(c => c.map_node_id === node.id);
                  const st = stages.find(s => s.key === node.stage_key);
                  return (
                    <div className="mt-3">
                      <div className="text-xs font-semibold text-gray-500 mb-1">🧷 Test holati</div>
                      {mine.map(c => (
                        <div key={c.id} className="flex items-center gap-2 text-xs mb-1">
                          <span className="truncate flex-1 text-gray-700 dark:text-gray-200" translate="no" title={c.label}>{c.label} · {fmt(c.created_at)}</span>
                          <button type="button" className={`${btnGray} !px-2 !py-0.5 !text-xs`} disabled={!!ts.op} onClick={() => tsRestore(c)} title="Test muhitini shu joydan keyingi holatga qaytarish (~1 daqiqa)">⟲ Tiklash</button>
                        </div>
                      ))}
                      <button type="button" className={`${btnGray} ${btnSm} !text-xs`} disabled={!!ts.op}
                        onClick={() => tsSave(`${st ? `${stages.indexOf(st) + 1}. ${st.title} — ` : ''}${node.title}`, node.id)}
                        title="Hozirgi test muhitini shu joydan KEYINGI holat sifatida saqlash — keyingi qadamni shu yerdan boshlab sinash uchun">💾 Shu joydan keyingi holatni saqlash</button>
                    </div>
                  );
                })()}

                {(node.tasks || []).length > 0 && (
                  <div className="mt-3">
                    <div className="text-xs font-semibold text-gray-500 mb-1">🛠 Shu joy vazifalari</div>
                    {node.tasks.map(t => <div key={t.id} className="text-xs text-gray-700 dark:text-gray-200 truncate" translate="no">#{t.id} · {t.status}{t.approved_at ? ' ✅' : ''} — {t.title}</div>)}
                  </div>
                )}

                {canTask && <div className="mt-3 border-t border-gray-100 dark:border-gray-700 pt-3">
                  <div className="text-xs font-semibold text-gray-500 mb-1">➕ Shu joyga vazifa</div>
                  <textarea className={inp} rows={3} value={taskText} onChange={e => setTaskText(e.target.value)}
                    placeholder="Mijoz nima so'radi: «tugma qizil bo'lsin, bekor qilishda sabab so'ralsin»" />
                  <div className="mt-1.5 flex flex-wrap items-center gap-2">
                    {agentOk && <button className={btnBlue} disabled={busy || !taskText.trim()} onClick={() => askAgent(node)}
                      title="Vazifani darhol bermay, avval 🧠 Loyiha agenti bilan kelishish: joy, rol, yo'l va oxirgi rasm xabarga qo'shiladi, agent savol berib yechim taklif qiladi, kelishgach vazifani o'zi yaratadi">
                      🧠 Agent bilan maslahat
                    </button>}
                    <button className={agentOk ? btnGray : btnBlue} disabled={busy || !taskText.trim()}
                      title={agentOk ? "Maslahatsiz — yozilgan matn bilan darhol vazifa" : undefined}
                      onClick={async () => { const d = await call('POST', `/project-maps/nodes/${node.id}/task`, { text: taskText }, null); if (d && d.taskId) { say(isClient ? `🙋 So'rov #${d.taskId} yuborildi — operator ko'rib chiqib ishga tushiradi` : `🛠 Vazifa #${d.taskId} yaratildi`); setTaskText(''); } }}>
                      Vazifa yaratish
                    </button>
                    {!agentOk && <span className="text-[11px] text-gray-500">{isClient ? "Joy va rasm vazifaga o'zi qo'shiladi; ish operator ko'rib chiqqach boshlanadi" : "Joy, rol, yo'l va oxirgi rasm vazifaga o'zi qo'shiladi"}</span>}
                  </div>
                  {agentOk && <div className="mt-1 text-[11px] text-gray-500">🧠 Agent joy, rol, yo'l va oxirgi rasmni ko'rib savol beradi va yechim taklif qiladi; kelishgach vazifani o'zi yaratadi va shu kartochkaga bog'laydi. «Vazifa yaratish» — maslahatsiz, darhol.</div>}
                </div>}
              </div>
            )}
          </div>
        )}
      </div>

      {rec && (
        <div className="fixed inset-0 z-[80] bg-black/60 flex items-center justify-center p-4" onClick={() => setRec(null)}>
          <div className="w-full max-w-md rounded-xl bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 p-4 space-y-2.5" onClick={e => e.stopPropagation()}>
            <div className="font-semibold text-gray-900 dark:text-white">🎬 «{rec.stage.title}» etapini videoga olish</div>
            <p className="text-xs text-gray-600 dark:text-gray-300">Agent shu etapdagi joylarni tartib bilan ochib ko'rsatadi va tekshiradi, sinov videoga yoziladi. Har joyga yetganda kartochka videoning o'sha lahzasiga bog'lanadi — keyin «▶» bilan mijozga aynan shu joyni ko'rsatasiz. Bitta video = bitta mobil ilova (+ web panel).</p>
            <label className="block text-xs text-gray-500">📱 Mobil ilova
              <select className={inp} value={rec.mobileModuleId || ''} onChange={e => setRec({ ...rec, mobileModuleId: e.target.value ? Number(e.target.value) : '' })}>
                <option value="">— yo'q —</option>
                {(data.modules || []).filter(m => m.module_type === 'mobile').map(m => <option key={m.id} value={m.id}>{m.name}</option>)}
              </select>
            </label>
            <label className="block text-xs text-gray-500">🌐 Web panel
              <select className={inp} value={rec.webModuleId || ''} onChange={e => setRec({ ...rec, webModuleId: e.target.value ? Number(e.target.value) : '' })}>
                <option value="">— yo'q —</option>
                {(data.modules || []).filter(m => m.module_type === 'web' && m.test_url).map(m => <option key={m.id} value={m.id}>{m.name}</option>)}
              </select>
            </label>
            <label className="flex items-center gap-2 text-sm text-gray-700 dark:text-gray-200">
              <input type="checkbox" checked={!!rec.narrate} onChange={e => setRec({ ...rec, narrate: e.target.checked })} /> 🔊 Ovozli (agent nima qilayotganini aytib boradi)
            </label>
            <div className="text-xs text-gray-500">Videoga kiradigan kartochkalar: {recCount(rec)} ta (etapda jami {nodes.filter(n => n.stage_key === rec.stage.key).length})</div>
            <div className="flex gap-2 pt-1">
              <button className={btnBlue} disabled={busy || (!rec.mobileModuleId && !rec.webModuleId) || !recCount(rec)} onClick={startRec}>🎬 Boshlash</button>
              <button className={btnGray} onClick={() => setRec(null)}>Bekor qilish</button>
            </div>
          </div>
        </div>
      )}

      {lightbox && (
        <div className="fixed inset-0 z-[80] bg-black/80 flex items-center justify-center p-4" onClick={() => setLightbox(null)}>
          <div className="max-w-5xl max-h-full flex flex-col items-center gap-2" onClick={e => e.stopPropagation()}>
            <img src={media(lightbox.url)} alt="" className="max-h-[80vh] max-w-full object-contain rounded-lg" />
            <div className="text-xs text-gray-200 text-center" translate="no">{lightbox.surface === 'web' ? '🌐 Brauzer' : `📱 ${lightbox.surface || ''}`} · {fmt(lightbox.created_at)}{lightbox.note ? ` · ${lightbox.note}` : ''}{lightbox.run_id ? ` · sinov #${lightbox.run_id}` : ''}</div>
            <div className="flex gap-2">
              <a className={btnGray} href={media(lightbox.url)} target="_blank" rel="noreferrer">↗ Alohida ochish</a>
              {canEdit && <button className={btnGray} onClick={async () => { if (window.confirm('Bu rasm shu kartochkadan ajratilsinmi? (rasm faylining o\'zi o\'chmaydi)')) { const d = await call('DELETE', `/project-maps/evidence/${lightbox.id}`, null, 'Ajratildi'); if (d) setLightbox(null); } }}>Bu joyga tegishli emas</button>}
              <button className={btnGray} onClick={() => setLightbox(null)}>Yopish</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
